import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * provides callback to navigating to desired route..
 */
function useNavigateToSpecifiedRoute() {
  const history = useHistory();

  const navigateToSpecifiedRoute = useCallback(
    (path) => {
      history.push(path);
    },
    [history],
  );
  return {
    navigateToSpecifiedRoute,
  };
}

export default useNavigateToSpecifiedRoute;
